import * as React from "react";
import { EventCardProps } from "../../../EventCard/EventCard";
import { renderBetButtonsMultiview } from "./renderBetButtonsMultiview";
import { pickLiveOrPreliveId, prepareEmptyMarket, renderMarketsColumnsFilter } from "../../../../../../helpers";

export const renderMarketsMultiview = (cardProps: EventCardProps, buttonsHolderClass: string, componentPrefix: string, containerQueryParams?: any) => {
    let marketsInConfig = cardProps.sport.config.markets;
    let marketsInConfigTrimmed = renderMarketsColumnsFilter(marketsInConfig, containerQueryParams);

    return (
        <div key={`${componentPrefix}__buttons-holder__${cardProps.event.id}`} className={`rj-ev-list__${componentPrefix}__buttons-holder ${buttonsHolderClass}`} data-uat={`div-ev-list-${componentPrefix}-buttons-holder`}>
            {marketsInConfigTrimmed.map(
                (m, index) => {
                    let market = cardProps.markets.find(market => market.marketType.id === pickLiveOrPreliveId(m, cardProps.event.isLive));
                    let emptyMarket = prepareEmptyMarket(cardProps, m.template, index);

                    return renderBetButtonsMultiview(market || emptyMarket, cardProps.handlers.betButton, componentPrefix)
                })
            }
        </div>
    )
}